import { FilterValue } from "../Filters/FilterValue";
import { SortType } from "../SortType";

export interface LeadsFilters {
  page_no: number;
  search_text?: string;
  sources: FilterValue[] | null;
  limit: number;
  sort_by: string;
  sort_type: SortType;
}

export function parseQueryParamsForLeadsFilters(
  params: LeadsFilters | null,
  query_params: URLSearchParams,
): LeadsFilters {
  return {
    page_no: params?.page_no ?? 1,
    search_text: params?.search_text ?? "",
    sources: params?.sources ?? [],
    limit: params?.limit ?? 30,
    sort_by: params?.sort_by ?? "id",
    sort_type: params?.sort_type ?? SortType.DESC,
  };
}
